import logoSvg from "../img/logo-black.svg";
import renderHome from "./renderHome.js";

export default function initLogoAndTitle(contentDiv, isH1 = false) {
  const name = document.createElement(isH1 ? "h1" : "p");
  name.classList.add("name");
  name.textContent = "Integral Labs";

  const logoAndNameDiv = document.createElement("div");
  logoAndNameDiv.classList.add("logo-and-name");
  // logoImg removed for portfolio demo
  logoAndNameDiv.appendChild(name);

  // Add event listener (it renders the home page)
  logoAndNameDiv.contentDiv = contentDiv;
  logoAndNameDiv.addEventListener("click", (e) => {
    renderHome(e.currentTarget.contentDiv);
  });

  return logoAndNameDiv;
}
